import { Box, Button, Typography } from '@mui/material';
import ResponsiveLayout from '../../../../../components/common/ResponsiveLayout';
import { LISTING_EDIT_RESTRICTED_DAYS } from '../types';

export const DeniedEditState = ({ onClick }: { onClick: () => void }) => (
  <ResponsiveLayout>
    <Box sx={{ textAlign: 'center', maxWidth: '600px', p: 3 }}>
      <Typography variant="h4" color="error" gutterBottom>
        This Listing Was Taken Off The Market
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        This Listing was taken off the market more than{' '}
        {LISTING_EDIT_RESTRICTED_DAYS} days ago and can no longer be edited.
        Please contact Bright Customer Support if this listing is inaccurate or
        needs to be edited.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={onClick}
        sx={{ mt: 2 }}
      >
        OK
      </Button>
    </Box>
  </ResponsiveLayout>
);
